export const CANCEL_SUCCESS_TEXT = 'Boletos cancelados com sucesso. Lembre-se de cancelar os boletos no banco.';

export const CORA_CANCEL_REQUESTED_TEXT = 'Cancelamento solicitado. O boleto permanece ativo até a confirmação do banco.';

export interface BilletCancelMessage {
  severity: 'success' | 'info';
  title: string;
  text: string;
}

export function isCoraPluginBillet(billet: any): boolean {
  return billet?.bankNumber === 403 && billet?.pixCopyPast != null;
}

export function cancelSuccessMessage(selectedBillets: any[]): BilletCancelMessage {
  const billets = Array.isArray(selectedBillets) ? selectedBillets : [];
  const cora = billets.filter(isCoraPluginBillet).length;
  if (cora === 0) {
    return { severity: 'success', title: 'SUMMARY.SUCCESS', text: CANCEL_SUCCESS_TEXT };
  }
  if (cora === billets.length) {
    return { severity: 'info', title: 'SUMMARY.INFO', text: CORA_CANCEL_REQUESTED_TEXT };
  }
  return { severity: 'info', title: 'SUMMARY.INFO', text: `${CANCEL_SUCCESS_TEXT} ${CORA_CANCEL_REQUESTED_TEXT}` };
}
